import LanguageIcon from "@mui/icons-material/Language";
import { Menu, Slide } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import Action from "../components/Action";
const Menu_menu = styled(Menu)(({ theme }) => ({
    "& .MuiMenu-paper": {
        backgroundColor: "#eee !important",
        marginLeft: "-35px",
        "& ul li::before": {
            display: "none",
        },
    },
}));
const Img_countryFlag = styled("img")(({ theme }) => ({
    width: "30px",
    height: "20px",
}));
const ListItemText_countryLabel = styled(ListItemText)(({ theme, fontfamily }) => ({
    "& .MuiListItemText-primary": {
        fontSize: "1.6rem", //"var(--default-text-font-size)",
        fontFamily: fontfamily,
        color: "#001a37", //"var(--clr-primary)",
    },
}));
const LanguageSelector = (props) => {
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const getLanguageLink = (langcode) => {
        let currentUrl = window.location.href;
        let oldLanguageEntry = "/" + props.appModel.language + "/";
        let newLanguageEntry = "/" + langcode + "/";
        if (currentUrl.includes(oldLanguageEntry)) {
            return currentUrl.replace(oldLanguageEntry, newLanguageEntry);
        }
        return props.appModel.pathToAppRoot + langcode;
    };
    const renderListItems = () => {
        return props.appModel.config["supportedLanguages"].map((language) => {
            return (React.createElement(MenuItem, { style: { padding: "0.6rem 1.6rem 0 1.6rem", display: "flex" }, key: "languageItem_" + language.key, onClick: () => {
                    window.location.href = getLanguageLink(language.key);
                } },
                React.createElement(ListItemIcon, null,
                    React.createElement(Img_countryFlag, { src: props.appModel.pathToStatic +
                            "images/flags/" +
                            language.key +
                            ".png" })),
                React.createElement(ListItemText_countryLabel, { fontfamily: props.appModel.theme.fontFamily, primary: language.label })));
        });
    };
    const action = {
        label: props.appModel.i18n("action.title.language"),
        onClick: (event) => {
            setAnchorEl(event.currentTarget);
            setOpen(true);
        },
        image: React.createElement(LanguageIcon, null),
        toggleAction: true,
        checked: open,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Action, { action: action, appModel: props.appModel }),
        React.createElement(Menu_menu, { anchorEl: anchorEl, open: open, onClose: () => setOpen(false), TransitionComponent: Slide, anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
            } }, renderListItems())));
};
export default LanguageSelector;
